import { Media } from '@eiq/files/models';

import { HasConditions } from './has-conditions.model';

export class QuestionCard extends HasConditions {
  id: string;
  text: string;
  pinnedPositionInd: boolean;
  stimulus: Media;
}
